import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { PageFundsBooks } from '~/pages/funds/books/page.funds.books';
import { PageFundsContacts } from '~/pages/funds/contacts/page.funds.contacts';
import { PageFundsSearchResult } from '~/pages/funds/search-result/page.funds.search.result';
import { PageFundsRecent } from '~/pages/funds/recent/page.funds.recent';
import { PageLogin } from '~/pages/login/page.login';
import { PageNotFound } from '~/pages/page.notfound';
import { AppWrapper } from '~/views/organisms/wrapper-app/wrapper.app';
import { FundsWrapper } from '~/views/organisms/wrapper.funds';
import { ROUTES } from './routes';
import { PageFundsMedia } from '~/pages/funds/media/page.funds.media';
import { PageFundsCoverBook } from '~/pages/funds/books/cover-book';
import { ProtectedRouteComponent } from '~/views/organisms/protected-route-component';
import { accessLevels } from '~/shared/types';
import { RouteWrapper } from '~/views/organisms/route-wrapper';
const router = createBrowserRouter([
    {
        path: ROUTES.MAIN.path,
        element: _jsx(AppWrapper, {}),
        children: [
            {
                path: ROUTES.MAIN.path,
                element: _jsx(FundsWrapper, {}),
                children: [{ path: ROUTES.MAIN.path, element: _jsx(RouteWrapper, { component: _jsx(PageFundsRecent, {}) }) }],
            },
            { path: ROUTES.LOGIN.path, element: _jsx(PageLogin, {}) },
            {
                path: ROUTES.FUNDS.path,
                element: _jsx(FundsWrapper, {}),
                children: [
                    { path: ROUTES.FUNDS.path, element: _jsx(RouteWrapper, { component: _jsx(PageFundsRecent, {}) }) },
                    { path: ROUTES.FUNDS.MEDIA.path, element: _jsx(RouteWrapper, { component: _jsx(PageFundsMedia, {}) }) },
                    { path: ROUTES.FUNDS.BOOKS.path, element: _jsx(RouteWrapper, { component: _jsx(PageFundsBooks, {}) }) },
                    {
                        path: ROUTES.FUNDS.BOOKS.BOOK_COVER.path,
                        element: _jsx(RouteWrapper, { component: _jsx(PageFundsCoverBook, {}) }),
                    },
                    {
                        path: ROUTES.FUNDS.CONTACTS.path,
                        element: (_jsx(ProtectedRouteComponent, { component: _jsx(PageFundsContacts, {}), userRoles: accessLevels.user })),
                    },
                    {
                        path: ROUTES.FUNDS.MEDIA.SEARCH_RESULT.path,
                        element: _jsx(RouteWrapper, { component: _jsx(PageFundsSearchResult, {}) }),
                    },
                    {
                        path: ROUTES.FUNDS.MEDIA.SUB_CATEGORY.path,
                        element: _jsx(RouteWrapper, { component: _jsx(PageFundsMedia, {}) }),
                    },
                    {
                        path: ROUTES.FUNDS.MEDIA.CATEGORY_CONTENT.path,
                        element: _jsx(RouteWrapper, { component: _jsx(PageFundsSearchResult, {}) }),
                    },
                ],
            },
        ],
    },
    { path: '*', element: _jsx(PageNotFound, {}) },
]);
export const AppRouter = observer(() => {
    return _jsx(RouterProvider, { router: router, fallbackElement: true });
});
